
<po-page-list #poPageListComponent
  p-title="Relatório Mercado Interno"
  [p-breadcrumb]="breadcrumb"
>
  <div class="po-row">
    <po-lookup
      class="po-md-3"
      name="grupoCliente"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CA1GRPVEN"
      p-field-label="CACYDESCRI"
      p-field-value="CACYGRPVEN"
      p-label="Grupo Cliente"
      [p-columns]="columnsGrupoClienteFilters"
      [p-field-format]="fieldFormaterGrupoClienteFilters"
      [p-filter-service]="grupoClienteLookupService"
      [p-advanced-filters]="advancedGrupoClienteFilters"
      [p-literals]="{ modalTitle: 'Grupo Cliente' }"
    >
    </po-lookup>

    <po-button class="po-md-2 po-mb-2 po-mt-4" p-type="default" p-label="Pesquisar" (p-click)="loadLista()" > </po-button>

    <div class="po-md-5">&nbsp;</div>
    <po-button class="po-md-2 po-mb-2 po-mt-4" p-type="default" p-label="Excel" (p-click)="gerarExcel()" > </po-button>
  </div>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-hide-columns-manager="true"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>

</po-page-list>
